import React,{useState} from "react";
import { UploadOutlined } from "@ant-design/icons";
import { Collapse, Table, Button, Select, Upload } from "antd";
const { Panel } = Collapse;
const { Option } = Select;
const AppointmentManagerDashboard = () => {
    const [BookingHistory, setBookingHistory] = useState([
      {
        type: "CBC",
        name: "Random",
        contact: "123456",
        address: "New Delhi",
        status: "Sample Collected",
      },
      {
        type: "CBC",
        name: "Random",
        contact: "123456",
        address: "New Delhi",
        status: "Sample Collected",
      },
      {
        type: "CBC",
        name: "Random",
        contact: "123456",
        address: "New Delhi",
        status: "Sample Collected",
      },
    ]);
    const [newBookings, setBookings] = useState([
      {
        type: "CBC",
        name: "Random",
        contact: "123456",
      },
      {
        type: "CBC",
        name: "Random",
        contact: "123456",
      },
      {
        type: "CBC",
        name: "Random",
        contact: "123456",
      },
    ]);
  
    const bookingHistoryColumns = [
      {
        title: "Type",
        dataIndex: "type",
        key: "type",
      },
      {
        title: "Name",
        dataIndex: "name",
        key: "name",
      },
      {
        title: "Contact",
        dataIndex: "contact",
        key: "contact",
      },
      {
        title: "Address",
        dataIndex: "address",
        key: "address",
      },
      {
        title: "Status",
        dataIndex: "status",
        key: "status",
      },
      {
          title: "File Upload",
          key: "upload",
          render: (_, record) => (
            <Upload
              multiple={false} // Set to true if multiple file uploads are allowed
              beforeUpload={(file) => {
                console.log("Uploading file for:", record.name);
                console.log("File details:", file);
                // Add file handling logic here (e.g., send to backend)
                return false; // Prevent automatic upload
              }}
            >
              <Button icon={<UploadOutlined />}>Upload</Button>
            </Upload>
          ),
        },
    ];
    const bookingColumns = [
      {
        title: "Type",
        dataIndex: "type",
        key: "type",
      },
      {
        title: "Name",
        dataIndex: "name",
        key: "name",
      },
      {
        title: "Contact",
        dataIndex: "contact",
        key: "contact",
      },
      {
        title: "Action",
        key: "action",
        render: (_, record) => (
          <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
            <Button type="primary">Accept</Button>
            <Button type="primary" danger>
              Reject
            </Button>
          </div>
        ),
      },
    ];
    return (
      <div className="lab-test-appointment-manager">
        <Table
          title={() => <h2 style={{ margin: 0 }}>New Bookings</h2>} // Table title
          columns={bookingColumns}
          dataSource={newBookings}
          pagination={false}
        />
        <Table
          title={() => <h2 style={{ margin: 0 }}>Accepted Bookings</h2>} // Table title
          columns={bookingHistoryColumns}
          dataSource={BookingHistory}
          pagination={false}
        />
      </div>
    );
  };

  export default AppointmentManagerDashboard